import { normalizePath, transformPath, type Glyph } from './svg-glyph';

/**
 * The Mucka M (public/brand/mucka-icon-m.svg) as a filled glyph for the native
 * glass bar's Ask orb. The web draws it as a CSS mask of that file; native has
 * no CSS, so the path is carried here with the file's own group transform
 * (`translate(-85, 791) scale(0.1, -0.1)`) baked in, on its 854 × 558 box.
 *
 * Keep in step with the SVG — it is the brand mark, and it changes rarely.
 */
const M_PATH =
  'M1337 7422 l-487 -487 0 -2210 0 -2210 93 -93 92 -92 815 0 815 1 445 650 c245 357 447 654 448 659 2 6 -119 322 -268 703 l-272 692 -224 223 -224 222 540 0 c297 0 540 -2 540 -5 0 -2 -63 -90 -140 -195 -77 -104 -140 -194 -140 -200 0 -5 237 -616 526 -1357 384 -984 533 -1354 551 -1370 l24 -23 492 0 492 0 488 488 487 487 0 866 0 865 -168 220 -168 219 253 3 c139 1 368 1 508 0 l254 -3 -169 -220 -169 -220 -1 -1260 0 -1260 93 -93 92 -92 1125 0 1125 0 93 93 92 92 0 2605 0 2605 -93 93 -92 92 -1865 0 -1865 0 -93 -93 -92 -92 0 -802 0 -802 -85 -88 -85 -88 -85 88 -85 88 0 802 0 802 -93 93 -92 92 -1470 0 -1470 0 -488 -488z';

let cached: Glyph | null = null;

export function askMarkGlyph(): Glyph {
  if (!cached) {
    cached = {
      paths: [transformPath(normalizePath(M_PATH), [0.1, 0, 0, -0.1, -85, 791])],
      w: 854,
      h: 558,
      fill: true,
    };
  }
  return cached;
}
